/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCarrierDriverMessage.ts          *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/carrier-driver-message";

export class AutogenModelCarrierDriverMessage<RowType extends ModelRow> extends Endpoint<RowType, RowCarrierDriverMessageFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCarrierDriverMessage extends ModelRow<RowCarrierDriverMessageFields> {
	constructor(values?: Partial<RowCarrierDriverMessageFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCarrierDriverMessageFields {
	asset_driver_id: string;
	cancel_detail: string;
	canceled_date: Date;
	cancelled_scheduled_message: string;
	carrier_id: string;
	company_id: string;
	created_at_date: Date;
	customer_id: string;
	delivered_date: Date;
	delivery_mode: string;
	direction: string;
	direction_display: string;
	direction_text: string;
	dispatcher_user_id: string;
	driver_application_id: string;
	driver_id: number;
	driver_name: string;
	error_code: number;
	error_detail: string;
	hours: number;
	id: string;
	location_request_url: string;
	media: string;
	media_message_url: string;
	media_name: string;
	media_type: string;
	media_urls: string;
	message_count: number;
	message_id: string;
	message_read: string;
	message_sent: string;
	message_text: string;
	movement_id: string;
	name: string;
	next_scheduled_send_date: Date;
	number_of_update_attempts: number;
	operations_user: string;
	order_id: string;
	parent_row_id: string;
	phone_number: string;
	protected: string;
	recipient: string;
	recipient_name: string;
	recipient_opted_out: string;
	recurrence_enabled: string;
	recurrence_frequency: number;
	recurrence_termination: string;
	scheduled_message: string;
	scheduled_send_date: Date;
	send_date: Date;
	sender: string;
	status: string;
	status_display: string;
	token: string;
	total_messages: string;
	user_id: string;
	vendor_id: string;
	assigned_to: string;
	carrier_id: string;
	date_range: string;
	operations_user: string;
	order_id: string;
}

